module.exports = __webpack_public_path__ + "static/images/monet/email_field.png";